const getInitialLetters = (fullName) => fullName == null ? void 0 : fullName.split(" ").map((n) => n[0]).slice(0, 2).join("");
export {
  getInitialLetters as g
};
//# sourceMappingURL=getInitialLetters-CV7onXcH.js.map
